module.exports = __webpack_public_path__ + "static/img/logo.a1d8d574.svg";